import { Injectable } from "@angular/core";
import { EntityInfoTypeDbService } from "@app/entity/services/entityinfo-type-db.service";
import * as EntityInfoTypeActions from "@app/entity/store/actions/entityinfo-type.actions";
import { DataActions } from "@app/project/store/actions";
import { EffectsUtils } from "@app/root-store/effects/effect-creators";
import { Actions } from "@ngrx/effects";
import { map } from "rxjs";

const toAction = DataActions.toAction();

@Injectable()
export class EntityInfoTypeEffects extends EffectsUtils {
    constructor(actions$: Actions, private entityinfoTypeDbService: EntityInfoTypeDbService) {
        super(actions$);
    }

    getAllEntityInfoTypes$ = this.createSwitchEffect({
        dbMethod: () =>
            this.entityinfoTypeDbService.getAllEntityInfoTypes().pipe(
                map(xs => xs.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})),
                map(entityinfotypes => ({ entityinfotypes }))
            ),
        actionSet: EntityInfoTypeActions.loadSet,
    });
}
